<template>
    <div class="">
           <!-- Abdullah responsive added mx-3  -->
        <div class="row no-gutters py-2 mb-3 ml-3 custom-mobile-left-side-alignment-margin">
            <!-- Abdullah added ml-3  -->
           <div class="col-md-10 col-sm-12 " >
             <h4 class="atlhr-dashboard-title mt-10">
                 Documents <span class="black-title"></span>
                 <span>
                     <a v-bind:href="$api_url">Dashboard</a>
                         / Documents
                 </span>
             </h4>
           </div>
        </div>
          <!-- Abdullah responsive added mx-3  -->
        <div class="card mt-0 border-0 bg-wash no-shadow p-2 ml-3 custom-mobile-left-side-alignment-margin" v-if="company_access_settings['document_generation_access'] == true">
            <div class="card-header px-0 bg-transparent border-0 mobile-document-toolbar">
                <div class="row no-margin flex-wrap">

                    <b-dropdown :text="dropdown_text" class="trz-custom-dropdown ">

                        <b-dropdown-group id="dropdown-group-1" header= "HR Certificates">
                            <b-dropdown-item  @click="setModificationFlag(3)" ><b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Letter of Introduction</b-dropdown-item>
                            <b-dropdown-item  @click="setModificationFlag(4)" ><b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Increment Letter</b-dropdown-item>
                            <b-dropdown-item  @click="setModificationFlag(9)" ><b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Standard Salary Certificate (Current Salary)</b-dropdown-item>
                            <b-dropdown-item  @click="setModificationFlag(10)" ><b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Standard Salary Certificate (Period Range)</b-dropdown-item>
                        </b-dropdown-group>

                    </b-dropdown>

                    <div class="ml-1"  v-if="((modification_flag > 2))">
                        <div class="">
                            <b-button  class="mb-0 save_to_emplyee_btn " @click="downloadCertificate(1 , 1)">Save to Employee Profile</b-button>
                        </div>
                    </div>

                    <div class="ml-1"  v-if="modification_flag !=0">
                        <b-dropdown text="Downloads" class="trz-custom-dropdown mb-0" style="width:100%">
                            <!-- Modified by Faroque -->

                            <b-dropdown-group id="dropdown-group-1" v-if="((modification_flag > 2))">
                                <b-dropdown-item  @click="downloadCertificate(1 , 0)" ><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Save to Employee Profile and Download</b-dropdown-item>

                                <b-dropdown-item  @click="downloadCertificate(0 , 0)" ><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download</b-dropdown-item>
                            </b-dropdown-group>
                        </b-dropdown>
                    </div>

                    <div class="ml-1" v-if="modification_flag == 1 || modification_flag ==2">

                        <b-form-select id="fiscal_year" name="fiscal_year" v-model="fiscal_year" :options="fiscal_years"></b-form-select>
                    </div>

                    <div class="ml-1" v-if="modification_flag ==10">
                        <span class="">Fiscal Year : </span>
                        <b-form-select style="width:auto;" id="from_fiscal_year" name="from_fiscal_year" v-model="from_fiscal_year" :options="fiscal_years_salary"  @change="generateMonth(from_fiscal_year)"></b-form-select>

                    </div>
                    <div class="ml-1" v-if="modification_flag ==10 ">
                        <span class="">From : </span>
                        <b-form-select style="width:auto;" id="from_month" name="from_month" v-model="from_month" :options="from_month_array"></b-form-select>
                    </div>

                    <div class="ml-1" v-if="modification_flag ==10">
                        <span class="">To : </span>
                        <b-form-select style="width:auto;min-width: 155px;" id="to_month" name="to_month" v-model="to_month" :options="to_month_array_final"></b-form-select>
                    </div>

                    <div class="ml-1" v-if="modification_flag ==9">
                        <b-form-select id="salary_month" name="salary_month" v-model="salary_month" :options="month_array"></b-form-select>
                    </div>
                </div>
            </div>
            {{regenerateMonths}}
            {{sendFiscalYear}}


            <div v-if="emailing != ''" class="alert alert-info" role="alert"><img :src="$api_url+'/public/images/loading.gif'" width="20" class="mr-2"> We are initiating email sending process. Please wait, this may take few seconds... </div>
            <div v-if="emailing_success != ''" class="alert alert-success" role="alert"><b-icon icon="check-circle-fill" class="mr-2" variant="success"></b-icon> {{emailing_success}} </div>
            <div v-if="emailing_issue != ''" class="alert alert-warning" role="alert"><b-icon icon="exclamation-circle-fill" class="mr-2" variant="warning"></b-icon> {{emailing_issue}} </div>
        </div>
        <!-- Abdullah 20-05-26 added ml-3  -->
         <!-- Abdullah responsive added mx-3  -->
        <div class="mt-4 employee-tab leave-attendance-dashboard document-tab employee-investment-wrapper ml-3 custom-mobile-left-side-alignment-margin">
            <b-tabs pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">

                <template >
                    <b-tab lazy>
                        <template active v-slot:title>
                            <img v-bind:src="$api_url+'/images/Company Documents.png'"  class="img-fluid front-document-logo"  />
                            Company Documents

                        </template>
                        <div class="tab-item-wrapper">
                            <hr-policy-handbook-by-department-front  :flg="0"></hr-policy-handbook-by-department-front>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template active v-slot:title>
                            <img v-bind:src="$api_url+'/images/Tax Documents.png'"  class="img-fluid front-document-logo"  />Personal Documents

                        </template>
                        <div class="tab-item-wrapper">
                            <personal-documents-front  :flg="2"></personal-documents-front>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template active v-slot:title>
                            <img v-bind:src="$api_url+'/images/HR Documents.png'"  class="img-fluid front-document-logo"  />Tax Documents
                        </template>
                        <div class="tab-item-wrapper">
                            <tax-documents-front  :flg="2"></tax-documents-front>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                    <template active v-slot:title>
                        <img v-bind:src="$api_url + '/images/Company Documents.png'"
                            class="img-fluid front-document-logo" />
                        Employment Documents
                    </template>
                    <div class="tab-item-wrapper employee-table-wrapper mx-3 pb-3">
                        <employment-documents-front  :flg="2"></employment-documents-front>
                    </div>
                </b-tab>
                <b-tab lazy>
                        <template active v-slot:title>
                            <img v-bind:src="$api_url + '/images/Tax Documents.png'"
                                class="img-fluid front-document-logo" />Personal Tax Return Filing Acknowledgement

                        </template>
                        <div class="tab-item-wrapper mx-3 pb-3">
                            <personal-tax-return-filing-ack-front
                                :flg="2"></personal-tax-return-filing-ack-front>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template active v-slot:title>
                            <img v-bind:src="$api_url + '/images/HR Documents.png'"
                                class="img-fluid front-document-logo" />Other Documents

                        </template>
                        <div class="tab-item-wrapper mx-3 pb-3">
                            <other-documents-front  :flg="2"></other-documents-front>
                        </div>
                    </b-tab>

                    <!-- Added by Afrin start here -->
                    <b-tab lazy title-link-class="noc-tab-link">
                        <template active v-slot:title>
                            <img v-bind:src="$api_url + '/images/HR Documents.png'"
                                class="img-fluid front-document-logo" />NOC Documents
                        </template>
                        <div class="tab-item-wrapper mx-3 pb-3">
                            <employee-noc-documents-front :pageurl="this.$api_url + '/front'" :flg="2"></employee-noc-documents-front>
                        </div>
                    </b-tab>
                    <!-- Added by Afrin end here -->


                </template>

            </b-tabs>

        </div>
    </div>
 </template>
 <script>

     export default{

        mounted() {

        },
        props: ['pageurl'],
        data(){
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const currMonth =now.getMonth();

            var m_names = ['January', 'February', 'March',
                                'April', 'May', 'June', 'July',
                                'August', 'September', 'October', 'November', 'December'];


            const fullText2 = m_names[currMonth]+'-'+now.getFullYear();

            return {
                company_access_settings:{},
                common_list_fiscal_year:'',
                fiscal_year : '',
                to_fiscal_year : '',
                from_fiscal_year : '',
                fiscal_years_salary: [],
                fiscal_years: [],

                salary_month:fullText2,
                to_month:fullText2,
                from_month:fullText2,
                checkbox : 1,
                is_action : 0,
                list_key : 0,
                employees : [],
                default_column : ['name','phone','email','jobposition','department','branch'],
                primary_key : 'employee_id',
                company_options : [],
                appended_column : [],
                selected:[],

                modification_flag:0,

                output : '',
                download_loader : false,
                download_text : '',
                emailing_success : "",
                emailing_issue:'',
                emailing : '',
                dropdown_text: 'Choose Document',
                documents: [
                    { value: "3", text: "Letter of Introduction"},
                    {value: '4', text: "Increment Letter"},
                    {value: '9', text: "Standard Salary Certificate (Current Salary)"},
                    {value: '10', text: "Standard Salary Certificate (Period Range)"},
                ],

                month_array: [],
                to_month_array: [],
                to_month_array_final: [],
                from_month_array: [],
            }
        },
        methods:{
            get_access_settings: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/company/employee-access-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;

                    for (const [key, value] of Object.entries(company_access_settings_temp)) {

                            if(value==1)
                            {
                                company_access_settings_temp[key] = true;
                            }
                            else
                            {
                                company_access_settings_temp[key] = false;
                            }

                            }

                    this.company_access_settings = company_access_settings_temp;

                }.bind(this));
            },
            setModificationFlag(x){
                this.modification_flag = x;
                for(var i=0;i<this.documents.length;i++){
                    if(this.documents[i].value == x){
                        this.dropdown_text = this.documents[i].text;

                    }
                }

            },

            downloadCertificate(flag = 0 , file_only = 0)
            {
                if(!this.checkNet()) return false;

                if(this.modification_flag == 0){
                    this.$bvToast.toast("No document selected. Please select a document", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                }

                else
                {

                    if(this.modification_flag == 10)
                    {
                        var item  = this.to_month_array_final.find(item => item.value === this.to_month);

                        if(!item)
                        {
                            this.$bvToast.toast("Please select the Month range properly", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});

                            return 0;
                        }

                    }


                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                    formData.append('fiscal_year', this.fiscal_year);
                    formData.append('modification_flag', this.modification_flag);
                    formData.append('from_month', this.from_month);
                    formData.append('to_month', this.to_month);
                    formData.append('salary_month', this.salary_month);

                    formData.append('flag', flag);
                    formData.append('file_only', file_only);

                    var modification_flag =this.modification_flag;

                    currentObj.download_loader = true;

                    if(flag == 1 && file_only == 1)
                    {
                        currentObj.download_text = 'We are processing the files and this may take some time based on the number of employees selected.';

                        axios.post(this.$api_url+'/front/templates/downloadmultipletemplate', formData, config)
                        .then(function (response) {

                                if(response.data.errors)
                                {
                                    var errors = response.data.errors;
                                    errors.replace("<br>", "</br>");
                                    currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});

                                }

                                else
                                {
                                    currentObj.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                }

                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            })
                            .catch(function (error) {
                                currentObj.output = error;
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            });
                    }
                    else
                    {
                        currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';

                        axios.post(this.$api_url+'/front/templates/downloadmultipletemplate', formData, config)
                        .then(function (response) {

                            var fname=response.data.file_name;
                            if(response.data.download_file_name)
                                var download_f_name =   response.data.download_file_name;
                            else
                                var download_f_name =   fname;
                            if (download_f_name) {
                                // Fetch the generated zip as a blob instead of navigating away.
                                axios.post(currentObj.$api_url + '/front/templates/downloadzip', {
                                    file_name: fname,
                                    download_file_name: download_f_name,
                                    modification_flag: modification_flag,
                                }, {
                                    responseType: 'blob',
                                })
                                .then(function (dlResponse) {
                                    if (dlResponse.data.type === 'application/json') {
                                        let file = new Blob([dlResponse.data], { type: 'application/json' });
                                        Promise.resolve(file.text()).then(function (value) {
                                            let err_obj = JSON.parse(value);
                                            currentObj.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                                        });
                                    } else {
                                        currentObj.global_download_file_content(dlResponse);
                                    }
                                    currentObj.download_loader = false;
                                    currentObj.download_text = '';
                                })
                                .catch(function (error) {
                                    currentObj.output = error;
                                    currentObj.download_loader = false;
                                    currentObj.download_text = '';
                                });
                            } else {
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            }

                            if(response.data.errors)
                            {

                                var errors = response.data.errors;
                                errors.replace("<br>", "</br>");
                                currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});

                            }

                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                            })
                            .catch(function (error) {
                                currentObj.output = error;
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            });
                    }

                }
            },
            generateMonth(fiscal_year)
            {
                var fis_year = fiscal_year;
                var all_months = [];
                const fis_array = fis_year.split("-");
                var m_names = ['January', 'February', 'March',
                                'April', 'May', 'June', 'July',
                                'August', 'September', 'October', 'November', 'December'];

                for (let i = 6; i <= 11;)
                {
                    var fullText = m_names[i]+'-'+fis_array[0];
                    if(i==6)
                    {
                            this.from_month = fullText;
                            this.to_month = fullText;
                    }


                    all_months.push({value: fullText,text:fullText});
                    i++;
                }

                for (let i = 0; i <= 5;)
                {
                    var fullText = m_names[i]+'-'+fis_array[1];
                    all_months.push({value: fullText,text:fullText});
                    i++;
                }

                this.month_array = all_months;
                this.to_month_array = all_months;
                this.from_month_array = all_months;
                this.to_month_array_final = all_months;



            },
            getFiscalYearList: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url+'/get/fiscalyear/list' , {

                    }).then(function(response){
                    let fiscal_years_response = response.data;


                    let fy = [];

                    for(let i=0 ; i < response.data.length ; i++)
                    {
                        fy[i] = {value: response.data[i] , text: response.data[i] };
                    }

                    this.fiscal_years_salary =fy;
                    this.fiscal_years =fy;

                    this.fiscal_year =fiscal_years_response[0];
                    this.to_fiscal_year =fiscal_years_response[0];
                    this.from_fiscal_year =fiscal_years_response[0];
                    this.fiscal_year =fiscal_years_response[0];
                    this.generateMonth(this.fiscal_year);

                    }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
        },
        created: function(){
            this.get_access_settings();
            this.getFiscalYearList();
        },
        computed:
        {

            sendFiscalYear()
            {
                if(this.modification_flag == 1)
                {
                    this.common_list_fiscal_year = this.fiscal_year;
                    // this.getActiveEmployeeInRange(this.common_list_fiscal_year);
                }
                else
                {
                    // this.getEmployees();
                }

            },
            regenerateMonths()
            {

                var m_names = ['January', 'February', 'March',
                                'April', 'May', 'June', 'July',
                                'August', 'September', 'October', 'November', 'December'];


                if(this.to_month_array.length > 0)
                {


                    var item  = this.to_month_array.find(item => item.value === this.from_month);


                    //console.log(item);

                    if(item.text)
                    {
                        var from_mnth = item.text;
                        const str_month_arr_2 = from_mnth.split("-");
                        var f_year   = parseInt(str_month_arr_2[1]);
                        var f_month  = str_month_arr_2[0];
                        var f_month_final = m_names.indexOf(f_month);
                        var dt1   = 1;
                        const from_date = new Date(f_year,f_month_final,dt1);

                        var to_mon_array = [];

                        for (let i = 0; i <= 11;)
                        {

                            const str_month_arr_3 = this.to_month_array[i].text.split("-");
                            var f_year_1   = parseInt(str_month_arr_3[1]);
                            var f_month_1 = str_month_arr_3[0];
                            var f_month_final_1 = m_names.indexOf(f_month_1);
                            var dt1   = 1;
                            const to_date = new Date(f_year_1,f_month_final_1,dt1);

                            if(to_date.getTime() >= from_date.getTime())
                            {
                                var fullText = m_names[to_date.getMonth()]+'-'+to_date.getFullYear();
                                to_mon_array.push({value: fullText,text:fullText});
                            }


                            i++;
                        }

                        this.to_month_array_final = to_mon_array;


                    }
                }

            }
        }
     }


 </script>


